import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { memo, useCallback } from 'react';
import classnames from 'classnames';
import { keyboardMatch, keyboardKeys } from '@hh.ru/magritte-common-keyboard';
import { DotFilledSize24, ChevronRightOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { Action } from './Action.js';
import { TreeSelectorItemBase } from './TreeSelectorItemBase.js';
import { Text } from '@hh.ru/magritte-ui-typography';
import { s as styles } from './tree-selector-item-B-I_mxX1.js';
import '@hh.ru/magritte-ui-checkbox-radio';
import '@hh.ru/magritte-ui-cell';

const ItemContentComponent = ({ item, parentId, hasAction, hasChildren, letter, isExpanded, isDisabled, onExpansion, hasLetterOnLevel, isSelected, onChange, isIndeterminate, singleChoice, hasDot, maxControlsOnLevel, isSearch, renderItemForDesktop = TreeSelectorItemBase, }) => {
    const handleExpandableClick = useCallback(() => onExpansion && onExpansion(item.id), [item.id, onExpansion]);
    const currentActionCount = +hasDot + +hasAction + +hasChildren;
    const neededSpacesCount = maxControlsOnLevel - currentActionCount;
    const handleExpandableKeyDown = useCallback((event) => {
        if (keyboardMatch(event.nativeEvent, keyboardKeys.ArrowLeft)) {
            isExpanded && onExpansion(item.id);
            event.preventDefault();
            return;
        }
        if (keyboardMatch(event.nativeEvent, keyboardKeys.ArrowRight)) {
            !isExpanded && onExpansion(item.id);
            event.preventDefault();
        }
    }, [isExpanded, onExpansion, item.id]);
    const input = hasAction ? (jsx(Action, { selected: isSelected, onChange: onChange, id: item.id, onKeyDown: handleExpandableKeyDown, indeterminate: isIndeterminate, singleChoice: singleChoice, name: `tree-selector-item-${parentId || 'top'}-${item.id}` })) : undefined;
    return (jsxs("div", { className: classnames(styles.wrapper, {
            [styles.wrapperActive]: hasChildren || hasAction,
        }), onClick: hasChildren && !hasAction ? handleExpandableClick : undefined, children: [(letter || hasLetterOnLevel) && (jsx("div", { className: styles.letter, children: letter && (jsx(Text, { typography: "subtitle-1-semibold", style: "secondary", Element: "span", children: letter })) })), hasDot && (jsx("div", { className: styles.icon, children: jsx(DotFilledSize24, { initialColor: "tertiary" }) })), [...Array(neededSpacesCount).keys()].map((_, i) => (jsx("div", { className: styles.space }, i))), hasChildren && (jsx("div", { className: classnames(styles.icon, styles.iconActive, {
                    [styles.iconUp]: isExpanded,
                }), "data-qa": `tree-selector-chevron tree-selector-chevron-${item.id}`, onClick: hasAction ? handleExpandableClick : undefined, children: jsx(ChevronRightOutlinedSize24, { initialColor: "tertiary" }) })), renderItemForDesktop({ disabled: isDisabled, input, item, isSearch, isParent: hasChildren })] }));
};
const ItemContent = memo(ItemContentComponent);

export { ItemContent };
//# sourceMappingURL=ItemContent.js.map
